import { listBettingHousesNoClone, allSportsMinuscle } from "../components/variables/VariablesFilterSurebet";

export function FilterHead(){
  return ({
      'readLocalstorage':()=>{
          
          const listPatternValues = {  
              login: false,               
              profitMin: -999,
              profitMax: 999,
              time: 'qualquer horario',
              listBehomeEnabled: listBettingHousesNoClone,
              listSportsEnabled: allSportsMinuscle,
              trash: [],
              trash_aovivo:[],
              qauntityMoney: 1000,
              roundedValue: 1,
              roundedIsActive: false,
              statusMode: true,
              userData: {
                  "sessionID": "",
                  "id": "",
                  "nome": "",
                  "email": "",
                  "senha": "",
                  "plano": "",
                  "tipo_de_plano": "",
                  "status_da_conta": "",
                  "username": "",
                  "phone": "",
                  "cuponuser": null,
                  "data_cadastro": "",
                  "data_pagamento": null,
                  "data_expiracao": null,
                  "account_features": JSON.stringify([]),
              },
              Idinitialization:"",
              Amountinitialization:0,
              preferenceID:"",
              entradaslight:false,
              entradaspro:false,
              entradasGlobal: false,
              threeHouseEntryisActivated: false,
              preferenceData:{},
              session_id:"",
              hasPlan:false,
          };
          const listKeys = Object.keys(listPatternValues);

          for(let indexListKeys = 0; indexListKeys < listKeys.length; indexListKeys++){
              let keyLocalStorage = listKeys[indexListKeys];
              
              if( localStorage.getItem(keyLocalStorage) !== null ){                    
                  continue;
              }
              
              localStorage.setItem(keyLocalStorage,  JSON.stringify( listPatternValues[keyLocalStorage] ));
          }
         
          
      },
      'updateLocalStorage': (key, data) =>{
          const dataToJson = JSON.stringify( data );
          localStorage.setItem(key, dataToJson);
      }
  });
}